/**
 * API base URL for browser requests.
 * Production: empty string → same origin (/api via Traefik).
 * Dev: http://localhost:3001 when VITE_API_URL is unset.
 */
export function getApiBaseUrl(): string {
  const configuredUrl = import.meta.env.VITE_API_URL;
  if (typeof configuredUrl === 'string' && configuredUrl.length > 0) {
    return configuredUrl;
  }
  if (import.meta.env.DEV) {
    return 'http://localhost:3001';
  }
  return '';
}

/**
 * Resolve media paths like /uploads/... for <img src>.
 */
export function getMediaUrl(path: string | null | undefined): string | undefined {
  if (!path) {
    return undefined;
  }
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return `${getApiBaseUrl()}${path}`;
}
